import React from 'react'
import { PlusIcon } from '../../assets/icons/icon'
import { ButtonWithIcon } from './Buttons'
import { cn } from '../../lib/utils'

const Header = ({ title, subTitle, buttonText, handleClick, className, titleClass, actions, btnclass, Icon, iconClass, pageIcon }) => {
  return (
    <div className={cn("mb-8", className)}>
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          {pageIcon && (
            <div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center shadow-md">
              {pageIcon}
            </div>
          )}
          <div>
            <h1 className={cn("text-3xl font-bold text-gray-900 mb-2", titleClass)}>
              {title}
            </h1>
            {subTitle && (
              <p className={`text-gray-600 ${pageIcon && 'text-sm'}`}>
                {subTitle}
              </p>
            )}
          </div>
        </div>
        <div className="flex items-center gap-3">
          {/* Custom actions (if any) */}
          {actions}
          {buttonText && (
            <ButtonWithIcon text={buttonText} onClick={handleClick} Icon={Icon || PlusIcon} btnclass={btnclass} iconClass={iconClass} />
          )}
        </div>

      </div>
    </div>
  )
}

export default Header
